export enum CombisType {
    MANDATORY = 'MANDATORY',
    OPTIONAL = 'OPTIONAL',
    PSEUDO_MANDATORY = 'PSEUDO_MANDATORY',
}
